export const en = {
    common: {
        invest: "Invest",
        details: "Details",
        contact: "Contact",
        home: "Home",
        properties: "Properties",
        pricing: "Pricing",
        blog: "Blog",
        agents: "Agents",
        contactUs: "Contact Us",
        login: "Login",
        signup: "Sign Up",
        logout: "Logout",
        viewAll: "View All Properties",
        readyToInvest: "Ready to Invest?",
        getStarted: "Get Started",
    },
    home: {
        heroTitle: "Find Your Dream Home",
        heroSubtitle: "We help you find the best properties in town, turning your dreams into reality.",
        whyInvestTitle: "Why Invest in Real Estate?",
        featuredProperties: "Featured Properties",
        featuredSubtitle: "Handpicked properties by our team",
        investmentPlansTitle: "Investment Tiers",
        investmentPlansSubtitle: "Choose an investment tier that fits your strategy. Higher tiers offer shorter capital lock-in periods.",
        pricingCTA: "Discover the perfect investment tier for your financial goals, with flexible terms and competitive returns.",
        viewPricing: "View Tiers",
        exploreProperties: "Explore Opportunities",
    },
    whyInvest: {
        secure: "Secure Investment",
        secureDesc: "Rest assured with our secure investment solutions, your financial future is protected",
        transparent: "Transparent Platform",
        transparentDesc: "Experience the confidence of a transparent platform for your peace of mind",
        passive: "Passive Income",
        passiveDesc: "Explore opportunities for generating passive income streams",
        support: "Support",
        supportDesc: "Count on our dedicated support team for prompt and reliable assistance",
    },
    pricing: {
        starter: "Starter Plan",
        growth: "Growth Plan",
        premium: "Premium Plan",
        benefits: {
            noFees: "No hidden fees",
            support: "24/7 customer support",
            secure: "Secure blockchain payments",
            flexible: "Flexible investment terms",
        }
    },
    investment: {
        amount: "Investment Amount",
        period: "Investment Period",
        confirm: "Confirm Payment",
        minAmountError: "Minimum investment amount is $1,000",
        confirmTitle: "Review & Complete Investment",
        awaitingConfirmation: "Awaiting Payment Confirmation",
        statusPending: "Status: Pending Confirmation",
        viewMyInvestments: "View My Investments",
    }
};
